module.exports = __webpack_public_path__ + "site/img/servicecn.a8a99b09.png";